export default __webpack_public_path__ + "static/media/loaderWhite.3c541d2b.svg";